import React from "react";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import useVestigingRelation from "../../../components/Forms/useVestigingRelation";
import AuthProvider from "../../../auth/AuthProvider";
import CurrencyProvider from "../../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../../utils/formatting";
import { Link } from "react-router";
import parseJSONTryCatched from "../../../Helpers/JSONTryCatched";
import General from "./Tabs/General";

import { connect } from "react-redux";
import Products from "./Tabs/Products";
import ArrangementGroups from "./Tabs/ArrangementGroups";
import { useSwitchToSalesarea } from "../../Vestigingen/UseSwitchToSalesarea";

const endPoint = "core/arrangements";

function ArrangementForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"arrangements"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.name);
            }}
            customFieldSerialization={{
              products: (products) => JSON.stringify(products),
              arrangement_groups: (arrangement_groups) => JSON.stringify(arrangement_groups),
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{ raw_api_data: true }}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId: vestiging?.id ?? props.vestiging_id, menukaartVestigingId }}
            objectsExcludedAsRelation={{
              raw_api_data: true,
              products: true,
              arrangement_groups: true,
            }}
            onGetModel={onGetModel}
            pageTitle={getTranslation("arrangement.form.pageTitle", "Arrangements")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{
              raw_api_data: (response) => (response ? parseJSONTryCatched(response) : null),
            }}
            parseOutput={{}}
            rootRight={"arrangements"}
            tabs={(arrangementModel) => [
              {
                right: "general",
                tabButton: <TranslationWrapper tDefault={"General"} tKey={"arrangement.form.tabs.general"} />,
                tabContent: <General />,
              },
              ...(arrangementModel?.variant === "regular" || arrangementModel?.variant === "supplementary"
                ? [
                    {
                      right: "general",
                      tabButton: (
                        <TranslationWrapper
                          tDefault={"Arrangement Identifiers"}
                          tKey={"arrangement.form.tabs.products"}
                        />
                      ),
                      tabContent: <Products />,
                    },
                  ]
                : []),
              ...(arrangementModel?.variant != null
                ? [
                    {
                      right: "general",
                      tabButton: (
                        <TranslationWrapper
                          tDefault={"Arrangement Groups"}
                          tKey={"arrangement.form.tabs.arrangement_groups"}
                        />
                      ),
                      tabContent: <ArrangementGroups />,
                    },
                  ]
                : []),
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(ArrangementForm, vestigingStyle));
